import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  SourceSystem: 'SourceSystem',
  MappingType: 'MappingType'
};
const initialFilterState = {
  SourceSystem: '',
  MappingType: '',
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'SourceSystemMappingID',
  sortDirection: SortDirection.Asc,
};

export const sliceName = 'sourceSystemSearch';
const sourceSystemSearchSlice = createSearchPageSlice({
  sliceName,
  initialFilterState,
  filterFields,
  initialPageState
});

export const sourceSystemActions = sourceSystemSearchSlice.actions;
export default sourceSystemSearchSlice.reducer;
